export default {
  cart: [],
  buyer: [],
  orders: [],
  products: [
    {
      id: '1',
      image: 'https://i.ibb.co/GkpktVP/5882488ae81acb96424ffaaf.png',
      title: 'Hamburguesa Sencilla',
      price: 3.4,
      description: 'Hamburguesa sencilla ',
    },
    {
      id: '3',
      image:
        'https://i.ibb.co/D7FKfgB/kisspng-hamburger-shake-shack-new-york-city-cheeseburger-f-shack-burger-png-5a74922a422640-197265231.png',
      title: 'Hamburguesa doble',
      price: 3.4,
      description: 'Hamburguesa doble',
    },
    {
      id: '4',

      image:
        'https://i.ibb.co/Z8vG4D1/depositphotos-1098427-stock-photo-cheeseburger.jpg',
      title: 'Hamburgruesa',
      price: 3.4,
      description: 'hamburgruesa',
    },
    {
      id: '5',

      image: 'https://i.ibb.co/dLnxCb5/TELEBROSTY-Gaseosa-min1.jpg',
      title: 'gazimba',
      price: 1,
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    },
    {
      id: '6',
      image: 'https://i.ibb.co/z7QBdC9/7702090032017-20-201.jpg',
      title: 'gazimba',
      price: 1,
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    },
    {
      id: '7',
      image:
        'https://i.ibb.co/cT8C5Nk/Etiquetado-Manzana-sin-calorias-postobon-300-X1000.png',
      title: 'gazimba',
      price: 1,
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    },
  ],
};
